import { CircularProgress, Stack } from '@mui/material';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth';

export function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <Stack minHeight="100vh" alignItems="center" justifyContent="center"><CircularProgress /></Stack>;
  return user ? <Outlet /> : <Navigate to="/login" replace />;
}
